import { MeResponse, UserProfile } from '../hook/use-bxp-web-stargate-client.types';

export function mapMeResponseToUserProfile({ account_id, ...others }: MeResponse): UserProfile {
	return {
		accountId: account_id,
		...others,
	};
}
